import {useState, useEffect} from 'react'
import clsx from 'clsx'
import {ID} from '@/_metronic/helpers'
import {Card} from '@/components/Card'
import {PricingSerie} from '../../charts/core/_models'
import {getPricingEvolution} from '../../charts/core/_requests'
import PricingChart from '../../charts/PricingChart'

type PeriodProps = {
  slug: string,
  label: string
}

const periods: PeriodProps[] = [{
  label: 'Year', slug: 'year'
}, {
  label: 'Month', slug: 'month'
}, {
  label: 'Week', slug: 'week'
}]

type Props = {
  productId: ID
}

const PricingEvolutionChartCard: React.FC<Props> = ({productId}) => {
  const [period, setPeriod] = useState<string>('week')
  const [data, setData] = useState<Array<PricingSerie>|undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getPricingEvolution(productId, period)

        if (res) {
          setData(res)
        }
      } catch (e) {
        console.log(e)
      } finally {
        setIsLoading(false)
      }
    }

    isLoading && load()
  }, [isLoading, period, productId])

  return (
    <Card
      title="Pricing evolution"
      collapsable={false}
      className="card card-xl-stretch mb-xl-8"
      buttons={periods.map((p: PeriodProps) => ({
        label: p.label,
        className: clsx(
          'btn btn-sm btn-color-muted btn-active btn-active-primary me-3 ',
          {'active':  period === p.slug }
        ),
        onClick: ()=> {
          setPeriod(p.slug)
          setIsLoading(true)
        }
      }))}
    >
      {isLoading ? (
        <>Loading...</>
      ) : data === undefined ? (
        <>No data</>
      ) : (
        <PricingChart data={data} />
      )}
    </Card>
  )
}

export {PricingEvolutionChartCard}
